import { __assign, __rest } from "tslib";
/* eslint-disable @typescript-eslint/ban-types */
import React, { createElement, memo, useEffect, useRef } from 'react';
import { Route as ReactRoute, } from 'react-router';
import { SlardarInstance, useSlardar } from '../slardar';
var useSlardarRouteChange = function (slardarInstance, pid, manualPerformance) {
    var slardar = useSlardar(slardarInstance);
    var called = useRef(false);
    if (!called.current && slardar) {
        pid && slardar.set({ pid: pid });
        !manualPerformance && slardar.spaInit();
        called.current = true;
    }
    useEffect(function () {
        if (slardar && slardar.get('pid') === pid && SlardarInstance.lastSentPid !== pid) {
            !manualPerformance && slardar.spaSend();
            slardar.pv(pid);
            SlardarInstance.lastSentPid = pid;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
var SlardarRouteChange = function (_a) {
    var pid = _a.pid, manualPerformance = _a.manualPerformance, children = _a.children, slardar = _a.slardar;
    useSlardarRouteChange(slardar, pid, manualPerformance);
    return React.createElement(React.Fragment, null, children !== null && children !== void 0 ? children : null);
};
export var wrapRoute = function (RouteComp, _a) {
    var _b = _a === void 0 ? {} : _a, slardar = _b.slardar, globalManual = _b.manualPerformance;
    return memo(function (_a) {
        var children = _a.children, component = _a.component, render = _a.render, pid = _a.pid, manualPerformance = _a.manualPerformance, props = __rest(_a, ["children", "component", "render", "pid", "manualPerformance"]);
        var slardarProps = { manualPerformance: manualPerformance !== null && manualPerformance !== void 0 ? manualPerformance : globalManual, slardar: slardar };
        var newProps = props;
        var renderFactory = function (renderChildren) {
            return function (routeProps) {
                var _a, _b;
                if (!routeProps.match) {
                    return renderChildren(routeProps);
                }
                var matchedPid = (_b = pid !== null && pid !== void 0 ? pid : (_a = routeProps.match) === null || _a === void 0 ? void 0 : _a.path) !== null && _b !== void 0 ? _b : location.pathname;
                return (React.createElement(SlardarRouteChange, __assign({}, slardarProps, { pid: matchedPid, key: matchedPid }), renderChildren(routeProps)));
            };
        };
        if (render) {
            newProps.render = renderFactory(render);
        }
        if (component) {
            newProps.render = renderFactory(function (routeProps) { return createElement(component, routeProps); });
        }
        if (children) {
            if (typeof children === 'function') {
                // 若 children 为 function，无论如何都会执行
                // https://github.com/remix-run/react-router/blob/v5.3.0/packages/react-router/modules/Route.js
                newProps.children = renderFactory(children);
            }
            else {
                newProps.render = renderFactory(function () { return children; });
            }
        }
        return React.createElement(RouteComp, __assign({}, newProps));
    });
};
export var Route = wrapRoute(ReactRoute);
//# sourceMappingURL=router.js.map